import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { gutter } from '../../styles/mixins';

const Host = styled.div`
  flex-grow: 1;
  width: 100%;
  margin: 0 auto;
  padding-left: ${gutter(2)};
  padding-right: ${gutter(2)};
  max-width: ${({ theme }) =>
    theme.pageWidth + theme.breakpoints.sm.gutter * 2}px;

  @media ${device.mobile} {
    padding-left: ${({ theme }) => theme.breakpoints.sm.gutter}px;
    padding-right: ${({ theme }) => theme.breakpoints.sm.gutter}px;
  }

  @media ${device.tablet} {
    padding-left: ${({ theme }) => theme.breakpoints.md.gutter}px;
    padding-right: ${({ theme }) => theme.breakpoints.md.gutter}px;
    max-width: ${({ theme }) =>
      theme.pageWidth + theme.breakpoints.md.gutter * 2}px;
  }

  @media ${device.desktop} {
    padding-left: ${({ theme }) => theme.breakpoints.lg.gutter}px;
    padding-right: ${({ theme }) => theme.breakpoints.lg.gutter}px;
    max-width: ${({ theme }) =>
      theme.pageWidth + theme.breakpoints.lg.gutter * 2}px;
  }
`;

interface ContainerProps {
  children: React.ReactNode;
}

export const Container = ({ children }: ContainerProps) => {
  return <Host>{children}</Host>;
};
